export enum CrossBranchSharing {
    Inherited = 'Inherited',
    Enabled = 'Enabled',
    Disabled = 'Disabled',
}
